import { render, staticRenderFns } from "./AgentChangePassword.vue?vue&type=template&id=739d4e7c&scoped=true&"
import script from "./AgentChangePassword.vue?vue&type=script&lang=js&"
export * from "./AgentChangePassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "739d4e7c",
  null
  
)

export default component.exports